import { Row, Radio } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import './availabilityDuration.css';
import { notAllowedStatus } from '../constants/availabilityconstants';

const JobTypeTag = ({ availabilityStatus = [], checked, handleAvailabilityTypeChange, current_status }) => {
  const disabledBtn = !!(current_status && notAllowedStatus.indexOf(current_status.toLowerCase()) >= 0);
  let availabilityOptions;
  let isValid = false;
  if (Object.keys(availabilityStatus.length > 0)) {
    isValid = true;
    availabilityOptions = Object.values(availabilityStatus)
      .filter(avail => avail.status.toLowerCase() !== 'not available')
      .map((availability, index) => {
        if (availability.status && availability.status.toLowerCase() === 'full time') {
          availability.status = 'Yes';
        } else if (availability.status && availability.status.toLowerCase() === 'part time') {
          availability.status = 'No, only part-time.';
        } else if (availability.status && availability.status.toLowerCase() === 'pre-fulltime') {
          availability.status = 'I can start part-time immediately and then switch to full-time within a month';
        }
        return (
          <Radio key={availability.id} value={parseInt(availability.id, 10)} style={{ whiteSpace: 'normal', marginBottom: 8 }}>
            {availability.status}
          </Radio>
        );
      });
  }

  return (
    <div>
      <div className={disabledBtn ? 'availability-overlay' : 'hide-overlay'}>
          Your current status won&apos;t allow to change this option,<br />please contact support@turing.com
      </div>
      <Row type="flex">
        <Radio.Group value={parseInt(checked, 10)} onChange={(e) => handleAvailabilityTypeChange(e.target.value)}>
          {isValid && availabilityOptions}
        </Radio.Group>
      </Row>
    </div>
  );
};

JobTypeTag.propTypes = {
  availabilityStatus: PropTypes.object,
  checked: PropTypes.number,
  current_status: PropTypes.string,
  handleAvailabilityTypeChange: PropTypes.func
};

export default JobTypeTag;
